import { Minus, Plus } from "lucide-react";
import { useState } from "react";
import mockData from "./MockData";
import { useTranslation } from "react-i18next";

const FrequentlyAndAsk = () => {
  const { t } = useTranslation();
  const [activedIndex, setActiveIndex] = useState(null);
  const toggleFAQ = (index) => {
    setActiveIndex(activedIndex === index ? null : index);
  };

  return (
    <div>
      <div className="max-w-4xl mx-auto p-6">
        <h2 className="text-3xl font-bold text-center mb-8 font-playfair text-gray-800 my-5">
          {t("frequentlyAskedQuestions")}
        </h2>
        <div className="space-y-4">
          {mockData.faqData ? (
            mockData.faqData.map((faq, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg overflow-hidden shadow-sm"
              >
                <button
                  className="flex justify-between items-center w-full p-4 text-left font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                  onMouseEnter={() => toggleFAQ(index)}
                  onMouseOut={() => toggleFAQ()}
                >
                  <span> {t(faq.question)} </span>
                  <span> {activedIndex === index ? <Minus /> : <Plus />} </span>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    activedIndex === index
                      ? "max-h-96 opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="p-4 text-gray-600 bg-gray-50">
                    {t(faq.answer)}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div> {t("noDataFound")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FrequentlyAndAsk;
